import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GetTrackpropertyLink } from 'Api/PropertyApi';
import { Button, Col, Row } from 'react-bootstrap';
import ImageGallery from 'PropertiesViewPage/galleryPage';
import { toast } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { C } from '@fullcalendar/core/internal-common';
import { checkAuth } from 'Api/userapi';
import { useDispatch } from 'react-redux';
interface Visit {
  visitedAt: string;
  city: string;
  country: string;
  ipAddress: string;
  latitude: number;
  longitude: number;
  timezone: string;
}

interface Property {
  id: string;
  name: string;
  location: string;
  description: string;
  shortUrl: string;
  latitude: number;
  price: string;
  longitude: number;
  size: string;
  owner: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  propertyUrl: string;
  qrCode: string;
  createdAt: string;
  updatedAt: string;
  visitCount: number;
  photos: Array<{
    url: string;
    public_id: string;
    _id: string;
  }>;
  allVisits: Visit[];
}

const PropertyPage = () => {
  const { id } = useParams<{ id: string }>();
  const role = useSelector((state: RootState) => state.auth?.user?.role);
  const [property, setProperty] = useState<Property | null>(null);
  const [allVisits, setAllVisits] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const fetchRequested = useRef(false);
  const dispatch = useDispatch();
  const roleRef = useRef('guest');
  const navigate = useNavigate();

  const FetchPropertiesData = async (role = 'guest') => {
    if (fetchRequested.current) return;
    fetchRequested.current = true;
    setLoading(true);

    try {
      if (!id) {
        console.error('Id is missing.');
        return;
      }

      const visitedKey = `visited_property_${id}`;
      const locationResponse = await fetch(
        'https://ipinfo.io/json?token=4fef170f2c7869'
      );
      const locationData = await locationResponse.json();

      const userLocation = {
        ip: locationData.ip,
        city: locationData.city,
        region: locationData.region,
        country: locationData.country,
        loc: locationData.loc,
        org: locationData.org,
        postal: locationData.postal,
        timezone: locationData.timezone,
        latitude: locationData.loc.split(',')[0],
        longitude: locationData.loc.split(',')[1],
        role: role
      };

      const shouldCount = !sessionStorage.getItem(visitedKey);
      const response = await GetTrackpropertyLink(id, {
        ...userLocation,
        shouldCount
      });

      if (response.status === 200) {
        const { property, allVisits } = response.data;

        if (property && property.shortUrl === id) {
          setProperty(property);
          setAllVisits(allVisits);
          sessionStorage.setItem(visitedKey, 'true');
        } else {
          console.error('No matching property found.');
          toast.error('Property not found.');
        }
      } else {
        console.error('Error fetching properties. Status:', response.status);
        navigate('/')
        toast.error('Failed to load properties.');
      }
    } catch (error) {
      console.error('Error fetching properties:', error);
      toast.error('Error fetching properties.');
    } finally {
      fetchRequested.current = false;
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (id) {
  //     FetchPropertiesData();
  //   }
  // }, [id]);

  useEffect(() => {
    const init = async () => {
      try {
        const res = await checkAuth(dispatch);
        roleRef.current = res?.data?.user?.role || 'guest';
      } catch (err) {
        console.warn('User not logged in, continuing as guest');
      }

      if (id) {
        await FetchPropertiesData(roleRef.current);
      }
    };

    init();
  }, [id]);
  return (
    <>
      <div className="container-small">
        <Row className="g-5 mb-5 mb-lg-4 ">
          <Col xs={12} xl={12}>
            <div>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center "
                  style={{ height: '70vh', width: '60vw' }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <ImageGallery
                  property={property}
                  allVisits={allVisits}
                  id={id}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PropertyPage;
